import { IssueType } from "@/types/issueMonitoring.type";
import axios from "./api";
import { responseHandlerDefault } from "@/utils/handler.util";

export const getIssueType = (): Promise<IssueType[]> => {
  return axios.get<IssueType[]>(`/issuetype/`).then(responseHandlerDefault);
};
